import React from "react";
import ViewExamResultsState, { ViewExamResultsProps } from "./ViewExamResults.models";
import './ViewExamResults.scss';
import ViewExamResultImage from '../../../assest/images/card-image/ItemAvatar05.png';
import ExamResultService from "../../../services/exam/ExamResultService";
import AuthContext from "../../../contexts/AuthContext";
import CourseService from "../../../services/education/CourseService";
import { PeriodDateJson } from "../../../models/dtos/chart/PeriodDateJson";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import DatepickerLayout from "../../layouts/datepicker-layout/DatepickerLayout";
import { PeriodDate, PeriodDateTypeString } from "../../../models/interfaces/chart/PeriodDate";
import ViewExamResultFilterModal from "../view-exam-result-filter-modal/ViewExamResultFilterModal";
import ViewExamResultDetailsModal from "../view-exam-result-details-modal/ViewExamResultDetailsModal";
import { ExamResultsDTO } from "../../../models/dtos/exams/exam/ExamResultsDTO";
import { ExamTypes } from "../../../models/interfaces/exams/exam/ExamTypes";
import moment from 'jalali-moment';

export default class ViewExamResults extends React.PureComponent<ViewExamResultsProps, ViewExamResultsState>{
    static contextType = AuthContext;

    examResultService: ExamResultService;
    courseService: CourseService;
    detailsModal: React.RefObject<ViewExamResultDetailsModal>;
    filterModal: React.RefObject<ViewExamResultFilterModal>;
    constructor(props: any) {
        super(props);
        this.examResultService = new ExamResultService();
        this.courseService = new CourseService();
        this.detailsModal = React.createRef<ViewExamResultDetailsModal>();
        this.filterModal = React.createRef<ViewExamResultFilterModal>();
        this.state = { exams: [], hasData: false, periodTitle: PeriodDate.CurrentMonth, studentFieldId: 0, isActiveDatePicker: false };
    }

    componentDidMount = () => {
        this.recentlyExams();
        this.setState({ studentFieldId: this.context.userInformation.education.fieldId });
    }
    componentDidUpdate = () => {
        this.setState({ studentFieldId: this.context.userInformation.education.fieldId });
    }

    recentlyExams = () => {
        let self = this;
        this.examResultService.recentlyExams().then(function (response) {
            if (response.length === 0) {
                self.setState({ hasData: false, exams: [] });
            }
            else {
                self.setState({ hasData: true, exams: response });
            }
        });
    }

    selectPeridDate = (periodDate: PeriodDateJson, isClear?: boolean) => {
        let self = this;

        this.examResultService.getPage({
            courseId: isClear ? undefined : this.state.courseId,
            fromDate: periodDate.persianCreationFrom,
            toDate: periodDate.persianCreationTo
        }).then(function (response) {
            if (response.length === 0) {
                self.setState({ hasData: false, exams: [], selectedPeriod: periodDate, periodTitle: periodDate.periodDate });
            }
            else {
                self.setState({ hasData: true, exams: response, selectedPeriod: periodDate, periodTitle: periodDate.periodDate });
            }
        });
    }

    clear = () => {
        this.setState({ courseId: undefined });
        if (this.state.selectedPeriod != null)
            this.selectPeridDate(this.state.selectedPeriod, true);
    }


    selectedCourse = (value: any) => {
        this.setState({ courseId: value });
    }

    showExamDetail = (examResultId: number, examType?: ExamTypes, examId?: number) => {
        this.detailsModal.current?.openModal(examResultId, examType, examId);
    }

    showExamFilter = () => {
        this.filterModal.current?.openModal(this.state.studentFieldId);
    }

    onHandleDatePicker = (value: boolean) => {
        this.setState({ isActiveDatePicker: value })
    }

    render(): React.ReactNode {
        let { exams, hasData, periodTitle } = this.state;
        let content;
        if (hasData)
            content = (<>
                {this.foundDataView(exams, periodTitle)}
            </>);
        else content = (<>
            {this.notFoundDataView()}
        </>);

        return (<>
            <DatepickerLayout isActiveDatePicker={this.state.isActiveDatePicker} onHandleActiveDatePicker={this.onHandleDatePicker} showFooter={false} afterInit={periodTitle} afterSelect={this.selectPeridDate} children={content} headerAction={false} title="مشاهده نتایج آزمون" />

            <ViewExamResultFilterModal ref={this.filterModal} selectedCourse={this.selectedCourse} onAction={this.selectPeridDate} onDelete={this.clear} selectedPriodRange={this.state.selectedPeriod} />
            <ViewExamResultDetailsModal ref={this.detailsModal} />
        </>);
    }

    foundDataView(exams: ExamResultsDTO[],
        periodTitle: PeriodDate) {
        return (<>
            <div className="Found-data view-exam-result-area">
                <div className="tk-header" style={{ marginBottom: "0px" }}>
                    <label>عملکرد من در {PeriodDateTypeString(periodTitle)}</label>
                    <label className="mdi mdi-filter-menu-outline filter" onClick={this.showExamFilter}></label>
                </div>

                <div className="dropdown-list" style={{ height: "80vh", overflowX: "hidden" }}>
                    {exams.map((exam, key) => {
                        return (
                            <div key={key} className="col-12 margin-top-large">
                                <div className="tk-card">
                                    <div className="card-icon">
                                        <img src={ViewExamResultImage} alt={"view exam result"} />
                                    </div>
                                    <div className="card-title">
                                        <label>{exam.examTitle}</label>
                                    </div>
                                    <div className="col-12 Exam-info">
                                        <div className="tk-inline">
                                            <div className="col-6 notspace">
                                                <label>تاریخ برگزاری</label>
                                            </div>
                                            <div className="col-6 notspace info">
                                                <label>{exam.examDate && moment(exam.examDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 Exam-info">
                                        <div className="tk-inline">
                                            <div className="col-6 notspace">
                                                <label>درصد آزمون</label>
                                            </div>
                                            <div className="col-6 notspace info" style={{ direction: "ltr" }}>
                                                <label>{exam.examPrecent} %</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 Exam-info">
                                        <button className="btn btn-primary" onClick={() => this.showExamDetail(exam.id, exam.examType, exam.examId)} >مشاهده جزئیات</button>
                                    </div>
                                </div>
                            </div>

                        );
                    })}
                </div>
            </div>
        </>);
    }

    notFoundDataView() {
        return (<div className="Found-data view-exam-result-area">
            <div className="tk-header" style={{ marginBottom: "0px" }}>
                <label>فیلتر ها</label>
                <label className="mdi mdi-filter-menu-outline filter" onClick={this.showExamFilter}></label>
            </div>

            <div className="dropdown-list" style={{ height: "64vh", overflowX: "hidden" }}>
                <NotFoundDataInDate title="در این بازه شما آزمونی نداده بودید" />
            </div>
        </div>);
    }
}